import { AspectRatio, Card, Divider, Group, ImageMantine, Text } from 'ui';

const Action = ({ children }: { children: React.ReactNode }) => {
  return (
    <Group wrap="nowrap" py={'xs'} px={'md'} gap={'sm'} justify="space-between">
      <Text>{children}</Text>
      <Text fz={10} fw={600} c={'mint.7'}>
        +1 action
      </Text>
    </Group>
  );
};

const Katherine = () => {
  return (
    <Card withBorder p={0}>
      <Group wrap="nowrap" p={'md'} gap={'sm'}>
        <AspectRatio ratio={1} w={45}>
          <ImageMantine
            src="https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/holidayPromotion/katherine.png"
            radius={90}
          />
        </AspectRatio>
        <Text fw={500} fz={14} c="gray.8">
          Katherine took these actions to help kids in foster care this Holiday Season
        </Text>
      </Group>
      <Divider />

      <Action>
        <Text fz={10} span c={'gray.6'}>
          Got the{' '}
        </Text>
        <Text fz={10} fw={600} span c={'gray.6'}>
          iPhone browser extension
        </Text>
      </Action>
      <Divider />

      <Action>
        <Text fz={10} fw={600} span c={'gray.6'}>
          Donated{' '}
        </Text>
        <Text fz={10} span c={'gray.6'}>
          to the local animal shelter
        </Text>
      </Action>
      <Divider />

      <Action>
        <Text fz={10} fw={600} span c={'gray.6'}>
          Donated{' '}
        </Text>
        <Text fz={10} span c={'gray.6'}>
          to her church
        </Text>
      </Action>
      <Divider />

      <Action>
        <Text fz={10} span c={'gray.6'}>
          Got the{' '}
        </Text>
        <Text fz={10} fw={600} span c={'gray.6'}>
          desktop browser extension
        </Text>
      </Action>
    </Card>
  );
};

export { Katherine };
